module.exports = __webpack_public_path__ + "img/logo-huddle-branco.b6805d05.png";